<template>
  <div class="salesflowcrm">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Salesflow CRM <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div v-if="activeIntegration">
              <font
                size="6"
                color="black"
                @click.prevent="toogleUpdateIntegration()">
                <i class="ik ik-settings" />
              </font>
            </div>
            <div v-else>
              <font
                size="6"
                color="gray">
                <i class="ik ik-settings" />
              </font>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="salesflowcrm"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com Salesflow CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Salesflow CRM</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="error" />
            <h6 class="text-center">
              Esta integração é configurada no Salesflow CRM acessando
              <a
                class="link"
                href="https://app.salesflowcrm.com.br/integrations/api4com"
                target="_blank">
                Configurações > Outras Integrações > Telefonia > Api4Com
              </a>
            </h6>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração com Salesflow CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Salesflow CRM removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialSalesflowCrm"
      title="Tutorial Salesflow CRM"
      video-url="https://www.youtube.com/embed/aGrJf03iUac" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationSalesflowCrm',
  components: {
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false
    }
  },
  mounted () {
    this.$nextTick(() => this.loadIntegration())
  },
  methods: {
    loadIntegration () {
      return loopback
        .get('/integrations?filter[where][gateway]=salesflowcrm')
        .then(integrations => {
          this.integration = integrations.pop()
          this.configReady = true
        })
        .catch(err => { this.$emit('onError', err) })
    },
    saveIntegration () {
      this.error = null
      const integrationParams = {
        gateway: 'salesflowcrm',
        webhook: true,
        webhookConstraint: {
          event: {
            gateway: 'salesflowcrm'
          }
        },
        metadata: {
          webhookUrl: 'https://app.salesflowcrm.com.br/hook/api4com',
          webhookVersion: 'v1.7',
          webhookTypes: ['channel-hangup']
        }
      }
      if (this.integration) integrationParams.id = this.integration.id
      loopback
        .patch('/integrations', integrationParams)
        .then(integration => {
          this.integration = integration
          $(this.$refs.updateIntegration).modal('hide')
          $(this.$refs.successIntegration).modal('show')
        })
        .catch(err => {
          this.error = err
          // TEL-2243: o `friendly` do interceptor ja resolve `details.messages` pelo
          // FIELD_MESSAGES, mantem em pt-BR o que o backend ja manda traduzido e nomeia
          // o campo quando nao ha texto proprio. Montar `lines` aqui devolvia o texto do
          // LoopBack em ingles e ainda sobrescrevia a traducao.
        })
    },
    toogleIntegration (event) {
      if (event.value === true) {
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.error = null
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    openTutorial () {
      this.$refs.tutorialSalesflowCrm.open()
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'salesflowcrm'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/SalesflowCrm.vue